import React, { ReactElement } from "react";
import { Card, CardContent, CardMedia, Typography, useTheme, Zoom } from "@mui/material"
import { LandingActionProps } from "./LandingAction";

interface LandingActionCardProps extends LandingActionProps {
    id: string;
}

export const LandingActionCard = ({
    menuItems, delay, id
}: LandingActionCardProps) => {

    const theme = useTheme();

    if (menuItems.length === 0) {
        return <></>
    }
    const { text, icon } = menuItems[0];

    const displayIcon = React.cloneElement(
        // Cloning requires any
        // eslint-disable-next-line        
        icon as ReactElement<any>,
        {
            id: `${id}-icon`,
            sx: {
                fontSize: 125,
                color: theme.palette.common.white,
                padding: '10px',
                margin: '30px 2px',
            }
        }
    );

    return (
        <Zoom in={true} timeout={800} style={{ transitionDelay: `${delay}ms` }}>
            <Card
                sx={{
                    backgroundColor: theme.palette.grey[500],
                    border: '1px solid',
                    borderColor: theme.palette.common.black,
                    color: 'white',
                    '&:hover': {
                        backgroundColor: theme.palette.grey[600],
                        color: 'white',
                    },
                }}
            >
                <CardMedia sx={{ color: 'black' }}>
                    {displayIcon}
                </CardMedia>
                <CardContent
                    sx={{
                        backgroundColor: theme.palette.grey[800],
                        paddingBottom: '16px !important',
                    }}
                >
                    <Typography
                        id={`${id}-text`}
                        sx={{ fontSize: '1.3rem' }}
                        variant="h5"
                    >
                        {text}
                    </Typography>
                </CardContent>
            </Card>
        </Zoom>
    )
}
